import React, {Fragment} from 'react';
import Box from '../layout/Box';
import createEditor from '../form/ComponentEditor';
import WriteOffList from "./lists/WriteOffList";
import WriteOffForm from "./forms/WriteOffForm";
import {postData} from "../../utils/request";
import Modal from "../layout/Modal";
import isEqual from "lodash-es/isEqual";
import BoxEditor from "./BoxEditor";
import ModalEditor from "./ModalEditor";
import shippingEditor from "./shippingEditor";
import Button from "../form/Button";
import StoreOrderEditor from "./storeorder/storeorderEditor";
import StockTransferForm from "./forms/stocktransferForm";

const stateConst = {
    TransferInitiated: 0,
    Modification: 50,
    UnderRevision: 100,
    MissingStock: 107,
    WaitingForStock: 110,
    StockReserved: 120,
    OriginStoreOrderDelete: 130,
    OriginStoreOrderSent: 200,
    OriginStoreOrderClaim: 210,
    OriginStoreOrderCompleted: 220,
    ShippingOrdered: 300,
    ShippingFailed: 310,
    ShippingCompleted: 320,
    DestinationStoreOrderSent: 400,
    DestinationStoreOrderClaim: 410,
    DestinationStoreOrderCompleted: 420,
    UnderClaimOld: 500,
    ClaimProcessed: 505,
    TransferProcessed: 510,
    UnderClaim: 511,
    TransferCompleted: 520,
    DeleteTransferInitiated: 900,
    DeleteStockReserved: 910,
    DeleteStoreOrderSent: 920,
    DeleteStoreOrderClaim: 930,
    DeleteStoreOrderCompleted: 940,
    WaitingForDeletePayment: 950,
    DeleteProcessed: 960,
    Deleted: 990,
};

const stateType = {};
Object.keys(stateConst).forEach((key) => {
    stateType[key] = state => state + "" === stateConst[key] + ""
});

class WriteOffEditor extends React.Component {

    stateButtons = (state) => {
        return {
            [stateConst.MissingStock + ""]: "Várakoztatás",
            [stateConst.OriginStoreOrderCompleted + ""]: "Szállítás újra rendelése"
        }[state + ""] || "Mehet";
    };

    stateButtonEnabled = (state) => [
        stateType.TransferInitiated,
        stateType.Modification,
        stateType.UnderRevision,
        stateType.MissingStock,
        stateType.WaitingForStock,
        stateType.StockReserved,
        stateType.OriginStoreOrderClaim,
        stateType.OriginStoreOrderCompleted,
        stateType.ShippingFailed,
        stateType.ShippingCompleted,
        stateType.DestinationStoreOrderClaim,
        stateType.DestinationStoreOrderCompleted,
        stateType.UnderClaimOld,
        stateType.TransferProcessed,
    ].filter((f) => f(state)).length;

    state = {
        modifyStock: false
    };

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (!isEqual(prevProps.values[prevProps.componentConfig.idfield], this.props.values[this.props.componentConfig.idfield])) {
            this.setState({modifyStock: false});
        }
    }

    setFieldValue = (field, value) => {
        this.props.setFieldValue(field, value);
    }

    proceedState = async () => {
        const values = this.props.values;
        await this.props.processAction(async () => {
            const response = await postData({
                action: this.props.componentConfig.componentname + '.proceedState',
                data: values
            });
            if (response.success) {
                this.list && this.list.refreshBackground();
                this.form && this.form.refreshBackground();
            }
            return response;
        });
    }

    modifyAction = async () => {
        const values = this.props.values;
        await this.props.processAction(async () => {
            const response = await postData({
                action: this.props.componentConfig.componentname + '.modifyAction',
                data: values
            });
            if (response.success) {
                this.list && this.list.refreshBackground();
                this.form && this.form.refreshBackground();
            }
            return response;
        });
    }

    modifyStock = async () => {
        if (!this.state.modifyStock) {
            this.setState({modifyStock: true});
            return;
        }
        const values = this.props.values;
        await this.props.processAction(async () => {
            const response = await postData({
                action: this.props.componentConfig.componentname + '.proceedState',
                data: values,
                modify_stock: true
            });
            if (response.success) {
                this.list && this.list.refreshBackground();
                this.form && this.form.refreshBackground();
            }
            this.setState({modifyStock: false});
            return response;
        });
    }

    render() {

        const isEditable =
            parseInt(this.props.values.state + "") <= 200
            && this.props.values.state + "" !== "50";

        const ShippingEditor = shippingEditor;

        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;

        const actionButtons = [];
        if (this.props.values.state + "" === "107") {
            actionButtons.push(
                <Fragment key="8">
                    <Modal
                        state={this.state.modifyStock ? "on" : "off"}
                        theme="default"
                        header="Biztos mehet?"
                        buttons={[
                            {
                                text: 'Mégse',
                                props: {color: "default", disabled: this.props.disabled || this.props.isLoading},
                                onClose: true,
                                onClick: async () => {
                                    try {
                                        this.setState({modifyStock: false});
                                    } catch (e) {

                                    }
                                }
                            },
                            {
                                text: 'Mehet',
                                props: {color: "primary", disabled: this.props.disabled || this.props.isLoading},
                                onClick: async () => {
                                    this.modifyStock();
                                }
                            }
                        ]}
                    >
                        Biztos elengeded? A hiányban lévő tételek módosításra kerülnek!
                    </Modal>
                    <Button
                        key="3"
                        disabled={this.props.isLoading || !this.stateButtonEnabled(this.props.values.state)}
                        color="primary"
                        className="pull-right"
                        onClick={this.modifyStock}
                    >
                        Mehet
                    </Button>
                </Fragment>
            );
        }
        actionButtons.push(
            <Button
                key="0"
                disabled={this.props.isLoading || !this.stateButtonEnabled(this.props.values.state)}
                color="primary"
                className="pull-right"
                onClick={this.proceedState}
            >
                {this.stateButtons(this.props.values.state)}
            </Button>
        );
        if (isEditable) {
            actionButtons.push(
                <Button
                    key="0"
                    disabled={this.props.isLoading}
                    color="warning"
                    className="pull-right"
                    onClick={this.modifyAction}
                >
                    Módosítás
                </Button>
            );
        }
        actionButtons.push(
            <Button
                key="1"
                disabled={!this.props.values[this.props.componentConfig.idfield] || !this.stateButtonEnabled(this.props.values.state)}
                color="danger"
                onClick={this.props.deleteForm}
            >
                Törlés
            </Button>
        );

        return (
            <Fragment>
                <List
                    {...this.props}
                    collapsed={this.props.collapsed || false}
                    theme="default"
                    header={"Leírás lista"}
                >
                    <WriteOffList ref={(el) => this.list = el} {...this.props} />
                </List>
                {this.props.values[this.props.componentConfig.idfield] && <Editor
                    {...this.props}
                    theme="default"
                    header={"Leírás adatai"}
                    footer={actionButtons}
                >
                    <WriteOffForm
                        stateConst={stateConst}
                        stateType={stateType}
                        ref={(form) => this.form = form}
                        {...this.props}
                    />
                </Editor>}
                {
                    this.props.values[this.props.componentConfig.idfield]
                    &&
                    (this.props.values.origin || {}).id !== (this.props.values.destination || {}).id
                    &&
                    <Fragment>
                        <StoreOrderEditor
                            editorContext="WriteOffStoreOrderEditorOut"
                            collapsed={!(parseInt(this.props.values.state + "") >= 200 && parseInt(this.props.values.state + "") <= 220)}
                            out={true}
                            client={this.props}
                            listFilter={[
                                {
                                    field: "client_component",
                                    value: this.props.componentConfig.componentname
                                },{
                                    field: "client_component_id",
                                    value: this.props.values[this.props.componentConfig.idfield]
                                }
                            ]}
                            editor={ModalEditor}
                            selection={null}
                            onProcessAction={() => {
                                if (!this.props.isLoading) {
                                    this.props.reloadForm && this.props.reloadForm();
                                }
                            }}
                        />
                        <ShippingEditor
                            editorContext="WriteOffShippingEditor"
                            gridid="WriteOffShippingList"
                            pageSize={0}
                            presets={{
                                client_component: this.props.componentConfig.componentname,
                                client_component_type: this.props.componentConfig.componentname,
                                client_component_id: this.props.values[this.props.componentConfig.idfield],
                            }}
                            collapsed={!(parseInt(this.props.values.state + "") >= 220 && parseInt(this.props.values.state + "") < 400)}
                            editor={ModalEditor}
                            businessComponent={this.props}
                            disable={!(stateType.ShippingFailed(this.props.values.state) || stateType.OriginStoreOrderCompleted(this.props.values.state))}
                            selection={null}
                            saveForm={async () => {
                                this.props.reloadForm && this.props.reloadForm();
                            }}
                            onProcessAction={() => {
                                if (!this.props.isLoading) {
                                    this.props.reloadForm && this.props.reloadForm();
                                }
                            }}
                        />
                    </Fragment>
                }
            </Fragment>
        );
    }
}

export default createEditor({
    editor: "WriteOffs",
    componentName: "WriteOff",
    WrappedComponent: WriteOffEditor,
    props: {
        view: "admin"
    }
});
